import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';
import { EMPTY_ENTRY, subscribeToCylindoStore, getCylindoEntry, requestCylindoFetch } from './utils';
const useCylindoCache = (productId, isCylindoProduct) => {
  const $ = _c(6);
  if (productId && isCylindoProduct) {
    requestCylindoFetch(productId);
  }
  let t0;
  if ($[0] !== productId) {
    t0 = () => getCylindoEntry(productId);
    $[0] = productId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getSnapshot = t0;
  const getServerSnapshot = _temp;
  const {
    config,
    version,
    loading
  } = useSyncExternalStore(subscribeToCylindoStore, getSnapshot, getServerSnapshot);
  let t1;
  if ($[2] !== config || $[3] !== loading || $[4] !== version) {
    t1 = {
      config,
      version,
      loading
    };
    $[2] = config;
    $[3] = loading;
    $[4] = version;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default useCylindoCache;
function _temp() {
  return EMPTY_ENTRY;
}